/**
 * Extract the first YouTube video ID from a URL or block of text. Handles the URL shapes
 * authors actually paste: watch URLs with `v=` in any query position, embed/shorts/live paths,
 * youtu.be short links, and the youtube-nocookie.com embed domain.
 */
export function extractYouTubeId(text?: string | null): string | null {
  if (!text) return null;
  const re =
    /(?:youtube(?:-nocookie)?\.com\/(?:watch\?(?:[^#\s"'&]*&)*v=|(?:embed|shorts|live)\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const match = text.match(re);
  return match ? match[1] : null;
}

/**
 * Public poster frame for a YouTube video, derived from a URL/text. Returns null when no video
 * id can be extracted. Used as a card thumbnail fallback when a module has no `thumbnail_url`.
 * `hqdefault` (480×360) always exists for a valid video; higher resolutions can 404.
 */
export function youTubeThumbnailUrl(text?: string | null): string | null {
  const id = extractYouTubeId(text);
  return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : null;
}
